<template lang="html">
  <div id="product-detail-page" data-aos="fade">
    <section class="container main-section">
      <div class="row">
        <div class="col-12 col-info">
          <h2 class="mb-3 title-s1">Tira de exhibidora de impulso</h2>
        </div>

        <div class="col-lg-5 col-gallery">
          <div class="box-gallery">
            <img src="public/images/pages/products/product-2-xl.jpg">
          </div>
        </div>

        <div class="col-lg-7 col-info">
          <!-- <h2 class="mb-3 title-s1">Tira de exhibidora de impulso</h2> -->

          <div class="box-table">
            <h5 class="table-title">Catálogo de Productos Generales</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="td-label">Productos</th>
                    <th class="td-descr">Material Utilizado</th>
                    <th class="td-label">Dimensiones</th>
                    <th class="td-descr">Cant. De Ganchos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="td-label bg-1">Tira Sencilla</td>
                    <td class="td-descr bg-2">Polipropileno</td>
                    <td class="td-label bg-1">3.5 x 56 cm</td>
                    <td class="td-descr bg-2">12*</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">Tira Sencilla</td>
                    <td class="td-descr bg-2">PEAD</td>
                    <td class="td-label bg-1">3.5 x 56 cm</td>
                    <td class="td-descr bg-2">12*</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">Tira C/Cabezal</td>
                    <td class="td-descr bg-2">Poipropileno</td>
                    <td class="td-label bg-1">s/diseño</td>
                    <td class="td-descr bg-2">s/diseño</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-4 box-table">
            <h5 class="table-title">Resistencia Gramos por Gancho</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th class="td-label">Calibre</th>
                    <th class="td-descr">Mínimo</th>
                    <th class="td-label">Máximo</th>
                    <th class="td-descr">Cant. De Ganchos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="td-label bg-1">0.025"</td>
                    <td class="td-descr bg-2">50 gr</td>
                    <td class="td-label bg-1">150 gr</td>
                    <td class="td-descr bg-2">12</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">0.032"</td>
                    <td class="td-descr bg-2">150 gr</td>
                    <td class="td-label bg-1">350 gr</td>
                    <td class="td-descr bg-2">12</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">0.040"</td>
                    <td class="td-descr bg-2">350 gr</td>
                    <td class="td-label bg-1">750 gr</td>
                    <td class="td-descr bg-2">12</td>
                  </tr>
                  <tr>
                    <td class="td-label bg-1">Otros</td>
                    <td class="td-descr bg-2">s/diseño</td>
                    <td class="td-label bg-1">s/diseño</td>
                    <td class="td-descr bg-2">s/diseño</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <p class="mt-2 p-md text-justify">
            Este es un producto de alta conveniencia por sus resultados altamente probados en mercados tan competitivos como Norteamérica, Asia y Europa reduce el espacio necesario para exhibir y vender productos en supermercados,  autoservicios y tiendas. Facilita el conteo y distribucion, permite la permanencia de la marca en el punto de venta al ser reutilizable.
          </p>

          <div class="mt-4 box-table">
            <h5 class="table-title">Capacidad de proceso</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="bg-2">Pueden eliminarse o adicionarse ganchos.</td>
                  </tr>
                  <tr>
                    <td class="bg-1">Ideal para exhibición de productos en espacios limitados.</td>
                  </tr>
                  <tr>
                    <td class="bg-2">Diseño e impresión sobre sus necesidades y aplicaciones particulares.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mt-4 box-table">
            <h5 class="table-title">Aplicaciones Típicas</h5>

            <div class="table-responsive-lg">
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <td class="bg-2">Exhibición de productos para venta al público.</td>
                  </tr>
                  <tr>
                    <td class="bg-1">Ganancia de espacios en autoservicios.</td>
                  </tr>
                  <tr>
                    <td class="bg-2">Incrementa la presencia de la marca o producto usando menos espacio.</td>
                  </tr>
                  <tr>
                    <td class="bg-1">Manejo fácil y conveniente para el área de reparto.</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="p-md mt-4 text-justify">
              Estos valores son típicos y representan un promedio sobre las pruebas y los muestreos realizados en muestra naturales usando procedimientos de uso común así como datos proporcionados por nuestros proveedores, estos datos. Se dan sin garantía, ya que es creíble y obtenida de fuentes creibles y exactas para procesos plásticos laminados.
            </p>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
}
</script>
